import { render, staticRenderFns } from "./ProductoBarraFormComponent.vue?vue&type=template&id=04f7225c&"
import script from "./ProductoBarraFormComponent.vue?vue&type=script&lang=js&"
export * from "./ProductoBarraFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports